import { render } from "./RadioButtonOriginalType.vue?vue&type=template&id=22ed1562&scoped=true"
import script from "./RadioButtonOriginalType.vue?vue&type=script&lang=js"
export * from "./RadioButtonOriginalType.vue?vue&type=script&lang=js"

import "./RadioButtonOriginalType.vue?vue&type=style&index=0&id=22ed1562&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22ed1562"]])

export default __exports__